import React from 'react';
import { CtaButton } from './CtaButton';
import { CheckCircle2, PlayCircle, Gift, Layers } from 'lucide-react';
import { motion } from 'framer-motion';
const deliverables = ['Masterclasses grabadas', '+8 hs de reproducción', 'Material descargable pdf', 'Workbooks de trabajo', 'Comunidad UGC', 'Feedback de Brenda', 'Guía y acompañamiento', 'Plantillas Portafolio UGC', 'Oportunidades Collabs', 'Tutoriales, Bonus y más!'];
const syllabus = ['1- Conceptos base del UGC', '2- Marketing UGC', '3- Storytelling UGC', '4- Estructura videos UGC', '5- Grabación + Edición UGC', '6- Armado de Portfolio UGC', '7- Tarifas y Packs UGC', '8- Outreach con las marcas', '9- Primeras Colaboraciones', '10-Maximiza tus ganancias', '11- Plataformas para crecer'];
export function ProgramDetails() {
  return <section className="px-6 py-10 flex flex-col items-center text-center max-w-7xl mx-auto pt-[0px] pb-[0px]" data-id="element-329">
      <div className="w-full max-w-6xl relative rounded-[3rem] p-[2px] bg-gradient-to-b from-[#D98BAF]/60 via-brand-navy to-brand-navy shadow-[0_20px_60px_-15px_rgba(31,31,46,0.5)]" data-id="element-330">
        <div className="bg-brand-navy rounded-[2.9rem] px-6 py-10 md:px-12 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-331">
          {/* Ambient glow */}
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#D98BAF]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-332" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-lavender/10 blur-[100px] rounded-full pointer-events-none" data-id="element-333" />

          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-334">
            <Gift size={16} strokeWidth={2.5} data-id="element-335" />
            Todo incluido
          </div>

          <h2 className="font-serif font-bold text-4xl md:text-6xl text-white mb-6 leading-tight relative z-10" data-id="element-336">
            ¿Qué vas a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark" data-id="element-337">
              recibir
            </span>
            ?
          </h2>

          <p className="font-bold uppercase tracking-widest text-[#D98BAF] text-lg md:text-xl mb-12 relative z-10" data-id="element-338">
            Acceso inmediato a 👇🏻
          </p>

          <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10 text-left max-w-5xl mx-auto relative z-10" data-id="element-339">
            {deliverables.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="flex items-center gap-3 bg-white/[0.03] border border-white/5 rounded-2xl p-4 hover:bg-white/[0.06] transition-colors" data-id="element-340">
                <CheckCircle2 className="text-[#D98BAF] shrink-0" size={22} strokeWidth={2.5} data-id="element-341" />
                <span className="font-medium text-white/90 text-base md:text-lg" data-id="element-342">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          <div className="w-full border-t border-white/10 pt-16 flex flex-col items-center relative z-10" data-id="element-343">
            <div className="inline-flex items-center gap-2 text-white/50 font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] mb-4" data-id="element-344">
              <Layers size={16} data-id="element-345" />
              Estructura paso a paso
            </div>
            <h3 className="font-serif font-bold text-3xl md:text-5xl text-white mb-12 leading-tight" data-id="element-346">
              Temario del Programa
            </h3>

            {/* Laptop image */}
            <div className="relative w-full max-w-4xl mb-12" data-id="element-347">
              <div className="absolute -inset-10 bg-gradient-to-tr from-[#D98BAF]/20 via-transparent to-[#D98BAF]/20 blur-3xl rounded-full opacity-60 pointer-events-none" data-id="element-348"></div>
              <img src="https://cdn.magicpatterns.com/uploads/17BXGsDi2bPr4y23Nvkykv/pasted-image.png" alt="Temario del programa en laptop" className="w-full h-auto relative z-10 drop-shadow-[0_30px_50px_rgba(0,0,0,0.5)]" data-id="element-349" />
            </div>

            {/* Syllabus dark box */}
            <div className="w-full max-w-4xl bg-[#0d0d12]/80 backdrop-blur-xl rounded-[2.5rem] p-8 md:p-14 shadow-2xl border border-[#D98BAF]/30 text-left mb-10 relative overflow-hidden" data-id="element-350">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D98BAF] to-transparent opacity-50" data-id="element-351"></div>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-5" data-id="element-352">
                {syllabus.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-353">
                    <span className="text-[#D98BAF] font-black text-lg mt-0.5" data-id="element-354">
                      •
                    </span>
                    <span className="font-medium text-white/80 text-lg md:text-xl" data-id="element-355">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="inline-flex items-center gap-2 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] mb-6" data-id="element-356">
              <PlayCircle size={18} data-id="element-357" />
              Sneak Peek
            </div>
            <p className="font-serif font-bold text-3xl md:text-4xl text-white mb-10" data-id="element-358">
              Así se ve por dentro 👇🏻
            </p>

            {/* Vimeo Video */}
            <div className="w-full max-w-2xl rounded-[2.5rem] overflow-hidden shadow-[0_0_50px_rgba(217,139,175,0.3)] bg-black aspect-[3/4] relative border border-white/10" data-id="element-359">
              <iframe src="https://player.vimeo.com/video/1162402905?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" className="absolute top-0 left-0 w-full h-full" title="Programa Formula UGC" data-id="element-360"></iframe>
            </div>

            <div className="w-full max-w-md md:scale-110 mt-16" data-id="element-361">
              <CtaButton variant="gold" className="shadow-[0_0_30px_rgba(212,175,55,0.4)]" data-id="element-362">
                ¡SI, QUIERO INSCRIBIRME!
              </CtaButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}